// Relative /api works in production (Nginx proxy) and in dev (CRA proxy in package.json)
export const API_URL = process.env.REACT_APP_API_URL || '/api';
